import React from 'react';
import './App.css';
import AnonPix from './components/anonpix';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background text-foreground">
        <AnonPix />
      </div>
    </ThemeProvider>
  );
}

export default App;
